import { z } from "zod";

export const groupFormSchema = z.object({
  name: z.string({ required_error: "NAME_REQUIRED" }).min(1, "NAME_REQUIRED"),
  description: z.string().max(200, "DESCRIPTION_REQUIRED").optional(),
  imageLink: z.string().optional(),
  users: z.array(z.number()).optional(),
  groupPrivacy: z.enum(["public", "private", "closed"]).default("public"),
});
